import React from "react";

function SeriesIcon() {
  return (
    <svg
      id="Group_32942"
      data-name="Group 32942"
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="61"
      viewBox="0 0 61 61"
    >
      <path
        id="Path_22240"
        data-name="Path 22240"
        d="M6.41,2h16.1a4.415,4.415,0,0,1,4.41,4.41V32.059a4.415,4.415,0,0,1-4.41,4.41H6.41A4.415,4.415,0,0,1,2,32.059V6.41A4.415,4.415,0,0,1,6.41,2ZM22.5,34.063a2,2,0,0,0,2-2h0V6.41a2,2,0,0,0-2-2H6.41a2,2,0,0,0-2,2V32.059a2,2,0,0,0,2,2ZM12.856,17.12a.886.886,0,0,1,1.406-.721v0l2.918,2.114a.888.888,0,0,1,0,1.437l-2.918,2.114a.888.888,0,0,1-1.406-.721Zm19.191-9.5H29.641V30.85h2.406Zm2.012,3.457h2.406V27.389H34.059Z"
        transform="translate(13.319 11.405)"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SeriesIcon;
